// UnsavedChangesDialog — confirmation dialog shown when navigating away with unsaved form edits.
// Matches the app's dark-theme inline dialog pattern.

interface UnsavedChangesDialogProps {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
}

export function UnsavedChangesDialog({ open, onStay, onLeave }: UnsavedChangesDialogProps) {
  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="unsaved-dialog-title"
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: '#0d1f30',
          border: '1px solid rgba(76,92,104,0.35)',
          borderRadius: '12px',
          padding: '28px 32px',
          maxWidth: '380px',
          width: '100%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        }}
      >
        <p
          id="unsaved-dialog-title"
          style={{ fontSize: '16px', fontWeight: 700, color: '#E8EDF2', margin: '0 0 8px' }}
        >
          Discard unsaved changes?
        </p>
        <p style={{ fontSize: '13px', color: '#8FA4B5', lineHeight: 1.6, margin: '0 0 24px' }}>
          You have unsaved edits in this form. Leaving now will discard them.
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onStay}
            autoFocus
            style={{
              padding: '7px 16px',
              backgroundColor: '#F5A621',
              color: '#021526',
              border: 'none',
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Stay
          </button>
          <button
            type="button"
            onClick={onLeave}
            style={{
              padding: '7px 16px',
              backgroundColor: 'transparent',
              color: '#8FA4B5',
              border: '1px solid rgba(76,92,104,0.35)',
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Leave
          </button>
        </div>
      </div>
    </div>
  );
}
